import React, { useEffect } from 'react';
import { Card, Form, Input, Button, Switch, Select, Divider, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

const { Option } = Select;

const Settings = () => {
  const [form] = Form.useForm();

  const handleSave = async (values) => {
    try {
      // 保存到localStorage
      localStorage.setItem('systemSettings', JSON.stringify(values));
      message.success('设置已保存');
      applySettings(values);
    } catch (error) {
      message.error('保存设置失败');
      console.error('保存设置错误:', error);
    }
  };

  const applySettings = (settings) => {
    // 应用主题
    if (settings.theme) {
      document.body.setAttribute('data-theme', settings.theme);
    }

    // 这里可以添加其他即时生效的设置应用逻辑
  };

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const savedSettings = localStorage.getItem('systemSettings');
        if (savedSettings) {
          const parsedSettings = JSON.parse(savedSettings);
          form.setFieldsValue(parsedSettings);
          applySettings(parsedSettings);
        }
      } catch (error) {
        console.error('加载设置错误:', error);
      }
    };

    loadSettings();
  }, [form]);

  return (
      <div className="settings-container" style={{ padding: '24px' }}>
        <Card className="settings-card">
          <Form
              form={form}
              layout="vertical"
              initialValues={{
                systemName: '染发配方管理系统',
                theme: 'dark',
                enableNotifications: true,
                defaultLanguage: 'zh_CN',
                pageSize: 10,
                autoLogout: 30,
              }}
              onFinish={handleSave}
          >
            {/* 原有表单内容保持不变 */}
            <Divider orientation="left">基本设置</Divider>
            <Form.Item
                name="systemName"
                label="系统名称"
                rules={[{ required: true, message: '请输入系统名称' }]}
            >
              <Input placeholder="请输入系统名称" />
            </Form.Item>

            <Form.Item
                name="theme"
                label="系统主题"
            >
              <Select>
                <Option value="dark">深色</Option>
                <Option value="light">浅色</Option>
                <Option value="blue">蓝色</Option>
              </Select>
            </Form.Item>

            <Form.Item
                name="enableNotifications"
                label="启用通知"
                valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Divider orientation="left">高级设置</Divider>
            <Form.Item
                name="defaultLanguage"
                label="默认语言"
            >
              <Select>
                <Option value="zh_CN">简体中文</Option>
                <Option value="en_US">English (US)</Option>
              </Select>
            </Form.Item>

            <Form.Item
                name="pageSize"
                label="每页显示条数"
            >
              <Select>
                <Option value={10}>10条/页</Option>
                <Option value={20}>20条/页</Option>
                <Option value={50}>50条/页</Option>
                <Option value={100}>100条/页</Option>
              </Select>
            </Form.Item>

            <Form.Item
                name="autoLogout"
                label="自动登出时间(分钟)"
            >
              <Select>
                <Option value={15}>15分钟</Option>
                <Option value={30}>30分钟</Option>
                <Option value={60}>60分钟</Option>
                <Option value={120}>120分钟</Option>
                <Option value={0}>永不</Option>
              </Select>
            </Form.Item>

            <Form.Item>
              <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
              >
                保存设置
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
  );
};

export default Settings;